import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import cn from 'classnames';
import { Box, Card, Collapse, Column, Row, Typography } from 'seagull';
import { ChevronDown, ChevronUp } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIsMobileForHomePage } from '~/hooks/useIsMobileForHomePage';
import { useLocaleKeys } from '~/i18n';
import styles from './SectionCard.module.scss';
export const GetSectionCardTID = (parentTestId)=>getTestIds(parentTestId);
export function SectionCard(param) {
    let { bi, testId, title, actions, showActions, children, bodyClassName, defaultExpanded } = param;
    const { SectionCardTestIds: TID } = useMemo(()=>GetSectionCardTID(testId), [
        testId
    ]);
    const { t: summaryTexts } = useLocaleKeys('pages.clientDetail.summary');
    const isMobile = useIsMobileForHomePage();
    const [expanded, setExpanded] = useState(defaultExpanded !== null && defaultExpanded !== void 0 ? defaultExpanded : !isMobile);
    if (isMobile) {
        const toggle = ()=>setExpanded((prev)=>!prev);
        const stopBubble = (e)=>e.stopPropagation();
        return /*#__PURE__*/ _jsxs(Box, {
            testId: testId,
            className: styles.mobileCard,
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    gap: 8,
                    alignItems: "center",
                    justifyContent: "space-between",
                    className: styles.mobileHeader,
                    onClick: toggle,
                    role: "button",
                    "aria-expanded": expanded,
                    "aria-label": expanded ? summaryTexts.collapseSection() : summaryTexts.expandSection(),
                    testId: TID.ToggleButton(),
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph1",
                            weight: "normal",
                            skin: "standard",
                            children: title
                        }),
                        /*#__PURE__*/ _jsxs(Row, {
                            gap: 12,
                            alignItems: "center",
                            children: [
                                expanded && showActions && /*#__PURE__*/ _jsx(Box, {
                                    onClick: stopBubble,
                                    children: actions
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    className: styles.chevron,
                                    children: expanded ? /*#__PURE__*/ _jsx(ChevronUp, {
                                        size: 20
                                    }) : /*#__PURE__*/ _jsx(ChevronDown, {
                                        size: 20
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Collapse, {
                    in: expanded,
                    children: /*#__PURE__*/ _jsx(Box, {
                        testId: TID.Body(),
                        className: styles.mobileBody,
                        children: children
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Card, {
        bi: bi,
        testId: testId,
        padding: "m",
        borderRadius: "m",
        disableSeparator: true,
        className: styles.desktopCard,
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 16,
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    gap: 8,
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph1",
                            weight: "normal",
                            skin: "standard",
                            children: title
                        }),
                        showActions && /*#__PURE__*/ _jsx(Box, {
                            children: actions
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Box, {
                    testId: TID.Body(),
                    className: cn(styles.body, bodyClassName),
                    children: children
                })
            ]
        })
    });
}
